module.exports = __webpack_public_path__ + "static/media/NT_HaiDang.919922aa.jpg";